export enum RecordStageEnum{
    ADDRESS = 'TO_REGISTER_ADDRESS',

    TO_REGISTER_LOCATION = 'TO_REGISTER_LOCATION',
    TO_REGISTER_PAPERS = 'TO_REGISTER_PAPERS',
    FEATURES_1 = 'TO_REGISTER_1_FEATURES',
    FEATURES_2 = 'TO_REGISTER_2_FEATURES',
    MULTIMEDIA = 'TO_REGISTER_MULTIMEDIA',
    TAGS = 'TO_REGISTER_TAGS',
    AD = 'TO_REGISTER_AD',
    ADS = 'TO_REGISTER_MORE_ADS',
    PRICE = 'PRICE',
    PUBLISH = 'TO_PUBLISH',
    COMPLETE = 'ALREADY_PUBLISHED',
}
